'use client';

import InstallBanner from '@alltrails/install-prompt/components/InstallBanner';
import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';
import type { TrailId } from '@alltrails/types/TrailId';

type TrailInstallPromptProps = {
  isBot: boolean;
  trailId: TrailId;
};

const TrailInstallPrompt = ({ isBot, trailId }: TrailInstallPromptProps) => {
  const [isBannerOpen, setIsBannerOpen] = useInstallPrompt('banner', !isBot);

  if (isBot) {
    return null;
  }

  return (
    <InstallBanner
      isOpen={isBannerOpen}
      deeplinkData={{ pageId: trailId, pageType: 'trail' }}
      onRequestClose={() => setIsBannerOpen(false)}
      promptLocation="trail page"
    />
  );
};

export default TrailInstallPrompt;
